import React, { useState, useCallback, useEffect } from "react";
import ReactModal from "react-modal";
import styles from "./styles.module.scss";
import { Loading } from "../../../../../../../components/Loading";
import { BrComerceApiService } from "../../../../../../../services/BrComerceApiService";
import Swal from "sweetalert2";
import Select from "react-select";
import { IoIosClose } from "react-icons/io";
import Title from "../Title";
import { selectStyle } from "../../../../../../../components/InputSelectAsync";
import { OwnDeliveryStatusEnum, OwnDeliveryStatusEnumArray, trackingEventById } from "./utils/TrackingEventsHandler";
import { UFsEnum } from "../../../../../../../enums/UFsEnum";
import { ownDeliveryNotDeliveredOptions } from "../EditPackageStatusModal/utils/packageDeliveryStatus";
import ShippingStagesEnum from "../../../../../../../enums/ShippingStagesEnum";

const stylesModal22 = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(51, 51, 51, 0.75)",
        zIndex: 999
    },
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        transform: "translate(-50%, -50%)",
        zIndex: 999,
        border: "none",
        backgroundColor: "transparent",
        padding: 0,
        overflow: "visible"
    }
};

const deliveryEnum = {
    delivered: "Entrega realizada",
    notDelivered: "Não foi possível entregar o objeto"
}

const deliveryOptions = [
    {
        value: deliveryEnum.delivered,
        label: "Sim"
    },
    {
        value: deliveryEnum.notDelivered,
        label: "Não"
    }
]

const UfsOptions = Object.keys(UFsEnum).map((uf) => ({
    value: UFsEnum[uf],
    label: UFsEnum[uf]
}));

const undeliveredOptions = Object.values(ownDeliveryNotDeliveredOptions);

const allTrackingOptions = OwnDeliveryStatusEnumArray.map((item) => {
    return {
        value: item.id,
        label: item.title,
        order: item.order
    }
});

export const AddTrackingEventModal = ({
    isOpen,
    handleCloseModal,
    shipping,
    refetch
}) => {
    const api = new BrComerceApiService();

    const [loading, setLoading] = useState(false)

    const [trackingEvent, setTrackingEvent] = useState()
    const [trackingEventError, setTrackingEventError] = useState()

    const [uf, setUf] = useState()
    const [ufError, setUfError] = useState()

    const [city, setCity] = useState()
    const [cityError, setCityError] = useState()

    const [addingDelivery, setAddingDelivery] = useState(false)
    const [delivered, setDelivered] = useState()
    const [deliveredError, setDeliveredError] = useState()

    const [undelivered, setUndelivered] = useState()
    const [undeliveredError, setUndeliveredError] = useState()

    async function handleSubmit() {
        const trackingData = trackingEventById(trackingEvent?.value);

        if (
            !trackingData && !addingDelivery
        ) {
            setTrackingEventError("Selecione um evento de rastreio");
            return;
        }

        if (!uf || !uf.value) {
            setUfError("Selecione uma UF");
            return;
        }

        if (!city || city.length < 3) {
            setCityError("Informe uma cidade válida");
            return;
        }

        let deliveryTitle
        let deliveryDescription

        if (addingDelivery) {
            if (!delivered || !delivered.value) {
                setDeliveredError("Informe se o objeto foi entregue");
                return
            }

            const isUndelivered = delivered.value === deliveryEnum.notDelivered;

            if (isUndelivered && (!undelivered || !undelivered.label)) {
                setUndeliveredError("Selecione a justificativa da não entrega");
                return
            }

            deliveryTitle = delivered.value;
            deliveryDescription = isUndelivered ? `A entrega não pode ser efetuada - ${undelivered.label}` : "Objeto entregue ao destinatário";

            if (!deliveryTitle || !deliveryDescription) {
                return;
            }
        }

        const data = {
            title: addingDelivery ? deliveryTitle : trackingData?.title,
            description: addingDelivery ? deliveryDescription : trackingData?.description,
            uf: uf?.value,
            city
        }

        try {
            setLoading(true)
            await api.makeHttpRequest({
                method: "PUT",
                url: `/shipping/${shipping.id}/addTracking`,
                data: { data }
            });
            Swal.fire({
                text: "Os evento foi registrado com sucesso.",
                title: "Sucesso!",
                icon: "success"
            });
        } catch (error) {
            const message = error?.response?.data?.message;

            Swal.fire({
                text: message ? message : "Ocorreu um erro ao registrar o evento.",
                title: message ? "Ocorreu um erro" : "Erro inesperado",
                icon: "error"
            });
        } finally {
            refetch()
            setLoading(false)
            handleCloseModal()
        }

    }

    const handleDefaultValues = () => {
        if (shipping) {
            const idShippingStatus = shipping.idShippingStatus;
            const isFirstStatus = idShippingStatus < OwnDeliveryStatusEnum.VALIDATED_OBJECT.id

            const isShippingNotDelivered = idShippingStatus === ShippingStagesEnum.NAO_FOI_POSSIVEL_ENTREGAR_O_OBJETO.id
            const statusId = isShippingNotDelivered ? ShippingStagesEnum.OBJETO_EM_TRANSITO.id : idShippingStatus
            const event = trackingEventById(statusId);



            if (allTrackingOptions.length && (!!event || isFirstStatus)) {

                const filteredOptions = allTrackingOptions.filter((option) => (isFirstStatus && option.order === 1) || option.order === (event?.order + 1));

                if (filteredOptions.length) {
                    setTrackingEvent(filteredOptions[0]);
                }
            }

            if (shipping.correiosRastreio?.length) {
                const lastItemIndex = shipping.correiosRastreio.length - 1;
                const lastTrack = shipping.correiosRastreio[lastItemIndex];

                if (lastTrack[1]?.uf) {
                    const ufOptions = UfsOptions.filter((option) => option.value === lastTrack[1].uf?.trim()?.toUpperCase());
                    setUf(ufOptions[0]);
                    setUfError();
                }

                if (lastTrack[1]?.cidade) {
                    handleInputCity(lastTrack[1].cidade);
                    setCityError();
                }
            } else if (!!shipping.origin) {
                const ufOptions = UfsOptions.filter((option) => option.value === shipping.origin?.state?.trim()?.toUpperCase());
                setUf(ufOptions[0]);
                setUfError();

                handleInputCity(shipping.origin?.city);
            }

            if (shipping.idShippingStatus === ShippingStagesEnum.OBJETO_SAIU_PARA_ENTREGA.id ||
                shipping.idShippingStatus === ShippingStagesEnum.OBJETO_NAO_FOI_ENTREGUE.id) {
                setAddingDelivery(true);
            } else {
                setAddingDelivery(false);
            }
        }
    }

    const onChangeUfOptions = (e) => {
        const ufOptions = UfsOptions.filter((option) => option.value === e.value);
        setUfError()

        if (ufOptions.length) {
            setUf(ufOptions[0]);
        }
    }

    const onChangeDeliveryOptions = (e) => {
        const deliveryOption = deliveryOptions.filter((option) => option.value === e.value);
        setDeliveredError()

        if (deliveryOption.length) {
            const delivery = deliveryOption[0];

            if (delivery.value === deliveryEnum.delivered) {
                setUndelivered();
            }

            setDelivered(delivery);
        }
    }

    const onChangeUndeliveredOptions = (e) => {
        const undeliveredOption = undeliveredOptions.filter((option) => option.value === e.value);
        setUndeliveredError()

        if (undeliveredOption.length) {
            setUndelivered(undeliveredOption[0]);
        }
    }

    const handleValidationCity = useCallback(value => {
        if (value.length === 0) {
            setCityError("Campo obrigatório");
        } else if (value.length < 3) {
            setCityError("Informe um nome válido para a cidade");
        } else {
            setCityError();
        }
    }, []);

    const handleInputCity = useCallback(
        value => {
            value = value?.replace(/[^a-zA-ZÀ-ÖØ-öø-ÿ\s]/g, "");
            value = value?.toUpperCase();
            setCity(value);
            handleValidationCity(value);
        },
        [handleValidationCity]
    );

    useEffect(() => {
        if (shipping) {
            try {
                setLoading(true)
                handleDefaultValues();
            } catch (e) {
                console.log({ e });
            } finally {
                setLoading(false)
            }
        }
    }, [shipping])

    if (loading) return <Loading loading={loading} />
    return (
        <>
            <ReactModal
                isOpen={isOpen}
                shouldCloseOnOverlayClick
                dialogClassName="schedule-pickup-modal"
                onRequestClose={handleCloseModal}
                style={stylesModal22}
                showCancelButton={true}
            >
                {shipping && !loading
                    ?
                    (<div className={styles.container}>
                        <div className={styles.closeButton}>
                            <button
                                onClick={handleCloseModal}
                            >
                                <IoIosClose />
                            </button>
                        </div>

                        <Title text={"Adicionar evento de rastreio"} />

                        <span>Adicione um evento de rastreio manualmente.</span>
                        <div className={styles.actionsContainer}>

                            <div className={styles.formContainer}>
                                <div className={styles.formSelect}>
                                    <span>Selecionar UF <strong style={{ color: "#eb0014" }}>*</strong></span>
                                    <div className={styles.select}>
                                        <Select
                                            onChange={onChangeUfOptions}
                                            options={UfsOptions}
                                            value={uf}
                                            placeholder="Nenhuma UF selecionada"
                                            styles={selectStyle}
                                            className={styles.select}
                                        />
                                        {ufError && <span className={styles.formErrorMsg}>{ufError}</span>}
                                    </div>
                                </div>
                                <div className={styles.formSelect}>
                                    <span>Cidade <strong style={{ color: "#eb0014" }}>*</strong></span>
                                    <div className={styles.input}>
                                        <input
                                            type="text"
                                            name="city"
                                            placeholder="Digite o nome da cidade"
                                            onChange={e => handleInputCity(e.target.value)}
                                            value={city}
                                        />
                                    </div>
                                    {cityError?.length && <span className={styles.formErrorMsg}>{cityError}</span>}
                                </div>
                                {!addingDelivery && <div className={styles.formSelect}>
                                    <span>Próximo Evento</span>
                                    <div className={styles.input}>
                                        <input
                                            type="text"
                                            name="event"
                                            placeholder="Nenhum evento identificado"
                                            value={trackingEvent?.label ?? ""}
                                            disabled
                                        />
                                    </div>
                                    {trackingEventError && <span className={styles.formErrorMsg}>{trackingEventError}</span>}
                                </div>}

                                {addingDelivery && <div className={styles.formSelect}>
                                    <span>O objeto foi entregue? <strong style={{ color: "#eb0014" }}>*</strong></span>
                                    <div className={styles.select}>
                                        <Select
                                            onChange={onChangeDeliveryOptions}
                                            options={deliveryOptions}
                                            value={delivered}
                                            placeholder="Selecione uma opção"
                                            styles={selectStyle}
                                            className={styles.select}
                                        />
                                        {deliveredError && <span className={styles.formErrorMsg}>{deliveredError}</span>}
                                    </div>
                                </div>}

                                {delivered?.value === deliveryEnum.notDelivered && <div className={styles.formSelect}>
                                    <span>Selecione o motivo <strong style={{ color: "#eb0014" }}>*</strong></span>
                                    <div className={styles.select}>
                                        <Select
                                            onChange={onChangeUndeliveredOptions}
                                            options={undeliveredOptions}
                                            value={undelivered}
                                            placeholder="Selecione uma opção"
                                            styles={selectStyle}
                                            className={styles.select}
                                        />
                                        {undeliveredError && <span className={styles.formErrorMsg}>{undeliveredError}</span>}
                                    </div>
                                </div>}
                            </div>

                            <div className={styles.buttonContainer}>
                                <button
                                    type="button"
                                    onClick={handleCloseModal}
                                    className={styles.buttonBack}
                                >
                                    Cancelar
                                </button>

                                <button onClick={handleSubmit} disabled={!!trackingEventError || !!ufError || !!cityError || !!deliveredError || !!undeliveredError} className={styles.buttonSave}>
                                    Salvar
                                </button>
                            </div>
                        </div>
                    </div>)
                    :
                    <div className={styles.container} style={{ maxWidth: "260px" }}>
                        <h2> Falha ao obter dados do objeto! </h2>
                    </div>}
            </ReactModal >
        </>
    );
};
